import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../services/api';
import './ContactUs.css';
import { useLanguage } from '../contexts/LanguageContext';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

export const AboutUs: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [supportInfo, setSupportInfo] = useState({ email: '', phone: '' });
  const [activeTab, setActiveTab] = useState<'contact' | 'privacy' | 'terms'>('contact');

  useEffect(() => {
    const fetchSupportInfo = async () => {
      try {
        const res = await apiService.getSupportInfo();
        setSupportInfo(res.data);
      } catch (err) {
        console.error('Failed to load support info', err);
      }
    };
    fetchSupportInfo();
  }, []);

  return (
    <div className="about-us-container">
      <div className="about-tabs">
        <button 
          className={`about-tab ${activeTab === 'contact' ? 'active' : ''}`}
          onClick={() => setActiveTab('contact')}
        >
          {language === 'vi' ? 'Liên hệ' : 'Contact Us'}
        </button>
        <button 
          className={`about-tab ${activeTab === 'privacy' ? 'active' : ''}`}
          onClick={() => setActiveTab('privacy')}
        >
          {language === 'vi' ? 'Chính sách bảo mật' : 'Privacy Policy'}
        </button>
        <button 
          className={`about-tab ${activeTab === 'terms' ? 'active' : ''}`}
          onClick={() => setActiveTab('terms')}
        >
          {language === 'vi' ? 'Điều khoản dịch vụ' : 'Terms of Service'}
        </button>
      </div>

      <div className="about-content">
        {activeTab === 'contact' && (
          <div className="contact-card">
            <h1 className="contact-title">{language === 'vi' ? 'Liên hệ với chúng tôi' : 'Contact Us'}</h1>
            <p className="contact-subtitle">
              {language === 'vi' 
                ? 'Chúng tôi luôn sẵn sàng hỗ trợ bạn. Vui lòng chọn một phương thức liên lạc dưới đây.' 
                : 'We are here to help. Please choose a contact method below.'}
            </p>

            <div className="contact-options">
              {/* Call Option */}
              <a href={`tel:${supportInfo.phone}`} className="contact-option-btn call-btn">
                <span className="contact-icon">📞</span>
                <div className="contact-info">
                  <h3>{language === 'vi' ? 'Gọi điện' : 'Call Us'}</h3>
                  <p>{supportInfo.phone || 'Loading...'}</p>
                </div>
              </a>

              {/* Email Option */}
              <a href={`mailto:${supportInfo.email}`} className="contact-option-btn email-btn">
                <span className="contact-icon">✉️</span>
                <div className="contact-info">
                  <h3>{language === 'vi' ? 'Gửi Email' : 'Email Us'}</h3>
                  <p>{supportInfo.email || 'Loading...'}</p>
                </div>
              </a>

              {/* Chat Option */}
              <button onClick={() => navigate('/contact/chat')} className="contact-option-btn chat-btn">
                <span className="contact-icon">💬</span>
                <div className="contact-info">
                  <h3>{language === 'vi' ? 'Chat trực tiếp' : 'Chat with Us'}</h3>
                  <p>{language === 'vi' ? 'Nhắn tin với quản trị viên' : 'Message the system admin directly'}</p>
                </div>
              </button>
            </div>
          </div>
        )}

        {activeTab === 'privacy' && (
          <div className="legal-embed-container">
             <PrivacyPolicy isEmbedded={true} />
          </div>
        )}

        {activeTab === 'terms' && (
          <div className="legal-embed-container">
             <TermsOfService isEmbedded={true} />
          </div>
        )}
      </div>
    </div>
  );
};
